/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import commonActions, { downloadPresignedUrlFile } from "../actions";
import Loader from "./Loader";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const ExportLinkRoutingPage = props => {
    const tabsOpen = localStorage.getItem("tabsOpen");
    const [loader, setLoader] = useState(false);
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        refreshExport();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.match.params.id]);

    const refreshExport = async () => {
        setLoader(true);
        const queryParams = new URLSearchParams(location.search);
        const isSmartChart = queryParams.get("smart_chart") === "true";
        await props.getLinkEmail({ id: `${props.match.params.id}`, smart_chart: isSmartChart });
        setLoader(false);
    };

    const ResData = props.commonReducer.getEmailItemResponse || {};
    const { status, s3_url, detail } = ResData;

    return (
        <>
            <LoadingOverlay active={loader} spinner={<Loader />} fadeSpeed={10}>
                <div className="error-sec">
                    <div className="col-md-12 navbarOtr">
                        <nav className="navbar navbar-expand-lg col-md-12">
                            {tabsOpen !== null && tabsOpen <= 1 ? (
                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                <a
                                    role="button"
                                    className="navbar-brand"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        history.push("/dashboard");
                                    }}
                                >
                                    <img src="/img/fca-logo.svg" alt="" />
                                </a>
                            ) : (
                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                <a className="navbar-brand">
                                    <img src="/img/fca-logo.svg" alt="" />
                                </a>
                            )}
                        </nav>
                    </div>
                    {status === true ? (
                        <div className="error-page expired-outer">
                            <div className="error-otr">
                                <div className="error-img">
                                    <img src="/img/download-smiely.svg" alt="" />
                                </div>
                                <h4>Your Download Has Been Initiated</h4>
                                <h5>
                                    Your Report Should Download Automatically, If Not, Click The Button Below to Download Your Recommendation Report
                                </h5>
                                <button onClick={() => downloadPresignedUrlFile(s3_url)} className="btn-blue-dwnlod">
                                    Download Recommendation Report
                                </button>
                            </div>
                        </div>
                    ) : status === false ? (
                        <div className="error-page expired-outer">
                            <div className="error-otr">
                                <div className="error-img">
                                    <img src="/img/expired-smiely.svg" alt="" />
                                </div>
                                <h4>Your Export Link Has Expired</h4>
                                <h5>Please contact our team or initiate a new Sorted Recommendation Report.</h5>
                            </div>
                        </div>
                    ) : (
                        <div className="error-page expired-outer">
                            <div className="error-otr">
                                <div className="error-img"></div>
                                <h4>{detail}</h4>
                            </div>
                        </div>
                    )}
                </div>
            </LoadingOverlay>
        </>
    );
};

const mapStateToProps = state => {
    const { commonReducer } = state;
    return { commonReducer };
};

export default connect(mapStateToProps, { ...commonActions })(ExportLinkRoutingPage);
